import CasesAboutBlock from "../../components/cases-page/cases-about-block/cases-about-block";
import CasesHeroBlock from "../../components/cases-page/cases-hero-block/cases-hero-block";
import iHero from "../../assets/img/main-page/case-mock-yoga.png";
import iMockAvatar from "../../assets/img/case-yoga-day-page/mock-avatar.png";
import CasesSwiperBlock from "../../components/cases-page/cases-swiper-block/cases-swiper-block";
import iSwiperMock from "../../assets/img/case-yoga-day-page/case-yoga-day-page-swiper-mock.png";
import iSwiperMock2 from "../../assets/img/case-yoga-day-page/case-yoga-day-page-swiper-mock-2.png";
import iSwiperMock3 from "../../assets/img/case-yoga-day-page/case-yoga-day-page-swiper-mock-3.png";
import iApproachMock from "../../assets/img/case-yoga-day-page/case-yoga-day-page-approach-mock.png";
import CasesApproachBlock from "../../components/cases-page/cases-approach-block/cases-approach-block";
import CasesHighlightsBlock from "../../components/cases-page/cases-highlights-block/cases-highlights-block";
import CasesReviewBlock from "../../components/cases-page/cases-review-block/cases-review-block";
import CasesListBlock from "../../components/cases-page/cases-list-block/cases-list-block";
import "./case-yoga-day-page.sass";

const CaseYogaDayPage = () => {
  const casesUlItems = [
    "Активно продвигать установку приложения через промоперсонал, предлагая приветственные подарки.",
    "Укреплять лидерство в сегменте online-продаж товаров, поддерживая высокую динамику роста.",
    "Использовать офлайн взаимодействие для демонстрации преимуществ приложения и его функционала.",
    "Разработать концепцию бренд-зоны, которая будет отражать ценности бренда и линковаться с темой самого фестиваля.",
    "Обеспечить позитивный опыт взаимодействия с брендом через персонализированные активности и подарки.",
  ];

  return (
    <div className="case-yoga-day-page page">
      <CasesHeroBlock
        img={iHero}
        title="БРЕНД-ЗОНА МЕГАМАРКЕТ
ДЛЯ ФЕСТИВАЛЯ YOGA DAY 2024"
        description="сделали фест на мульон человек за 5 дней, заработали кучу деняк и вкусно покушали"
      />

      <CasesAboutBlock>
        В гармонии с МегаМаркетом. Одним из самых ярких и запоминающихся событий
        лета 2024 года стала интеграция Мегамаркет в фестиваль Yoga Day, который
        прошел 23 июня в живописном парке-музее Царицыно в Москве.
        Это уникальное событие объединило в себе атмосферу йоги и креативный
        подход к продвижению бренда, создав неповторимую синергию.
      </CasesAboutBlock>

      <CasesHighlightsBlock
        stats={[
          {
            id: "1",
            color: { hex: "#72DB39" },
            description: "визуальных контактов (проходная яркая зона)",
            number: "100 000",
          },
          {
            id: "2",
            color: { hex: "#115EF3" },
            description: "информационных digital-контактов",
            number: "1 300 000",
          },
        ]}
      />

      <CasesListBlock
        title="Как интегрировать онлайн ритейлера в wellbeing мероприятие"
        ulItems={casesUlItems.map((item) => ({ text: item, id: item }))}
      />

      <CasesSwiperBlock
        images={[iHero, iSwiperMock, iSwiperMock2, iSwiperMock3]}
      />

      <CasesApproachBlock title="подход" img={iApproachMock}>
        Гости могли зарегистрироваться в мобильном приложении и получить на
        выбор освежающий смузи, стильный шоппер, бутылку для воды или перчатки
        для йоги. Баланс-борд стал испытанием на ловкость и выносливость,
        а победители получали шанс выиграть коврики для йоги от партнера Mela.
        Зона рефреша с визажистами, создающими легкий макияж с глиттером и
        неоновой подводкой, добавила ярких красок в образы гостей.
        А мастер-класс с чайной церемонией позволил погрузиться в мир ароматов и
        вкусов, доступных в Мегамаркет.
      </CasesApproachBlock>

      <CasesReviewBlock
        author={{
          name: "Иван Иванович, CMO/ Маркетинг директор",
          image: { url: iMockAvatar },
        }}
      >
        Недавно я побывал на мероприятии в Мегамаркете, и это было просто
        великолепно! Регистрация через мобильное приложение прошла быстро
        и удобно, а выбор подарков поразил: я выбрал стильный шоппер.
        Баланс-борд стал настоящим вызовом, и я был в восторге от шанса выиграть
        коврик для йоги. Зона с визажистами добавила веселья…
      </CasesReviewBlock>
    </div>
  );
};

export default CaseYogaDayPage;
